import { TaskCommentDto } from './task-comment.dto';

export class GetTaskCommentsResponseDto {
    taskComments: TaskCommentDto[];

    constructor(taskComments: TaskCommentDto[]) {
        this.taskComments = taskComments;
    }
}
